import { get, del, post, put } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const getCompanyTypeDef = () => get(url.COMPANY_TYPE_DEF)
export const addCompanyTypeDef = record => post(url.ADD_COMPANY_TYPE_DEF, record)
export const updateCompanyTypeDef = record => put(url.UPDATE_COMPANY_TYPE_DEF, record)
export const deleteCompanyTypeDef = guid => del(url.DELETE_COMPANY_TYPE_DEF, { params: { guid } })